<div fxLayout="row" fxLayoutAlign="space-between start" style="border-bottom: 1px solid #e2e2e2">
    <mat-form-field id="search-exercise-field">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput type="text" [(ngModel)]="searchText" placeholder="Search" [formControl]="search" />
    </mat-form-field>
    <button id="create-exercise-button" mat-raised-button color="primary" (click)="createNewExercise()" *ngIf="canEdit" [disabled]="!canEdit">Create New
    Exercise</button>
</div>

<mat-spinner *ngIf="loading" diameter="48" mode="indeterminate" style="margin: 2rem auto;"></mat-spinner>

<ng-container *ngIf="!loading">
    <cdk-virtual-scroll-viewport itemSize="36" style="height: 75vh;">
        <mat-action-list>
            <mat-list-item *cdkVirtualFor="let exercise of exercises | filterExercises: searchText" (click)="selectExercise(exercise)" [ngClass]="{ selected: selectedExercise === exercise }">
                {{ exercise.name }}
            </mat-list-item>
        </mat-action-list>
    </cdk-virtual-scroll-viewport>
</ng-container>